import { type IconProps, Icon } from "@chakra-ui/icon";

const AddUserIconGhost = (props: IconProps) => {
	return (
		<Icon
			viewBox="0 0 20 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M15.8333 5.83334V0.833336M13.3333 3.33334H18.3333M13.3333 15V14C13.3333 12.5999 13.3333 11.8998 13.0608 11.365C12.8211 10.8946 12.4387 10.5122 11.9683 10.2725C11.4335 10 10.7334 10 9.33329 10H5.66663C4.26649 10 3.56643 10 3.03165 10.2725C2.56124 10.5122 2.17879 10.8946 1.93911 11.365C1.66663 11.8998 1.66663 12.5999 1.66663 14V15M10.4166 3.75C10.4166 5.36083 9.11079 6.66667 7.49996 6.66667C5.88913 6.66667 4.58329 5.36083 4.58329 3.75C4.58329 2.13917 5.88913 0.833336 7.49996 0.833336C9.11079 0.833336 10.4166 2.13917 10.4166 3.75Z"
				stroke="currentColor"
				strokeWidth="1.66667"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Icon>
	);
};

export default AddUserIconGhost;
